import { useState } from 'react';

const readStoredIndex = (storageKey: string): number => {
  const stored = Number(sessionStorage.getItem(storageKey));
  return Number.isInteger(stored) && stored >= 0 ? stored : 0;
};

// Remembers the active tab of a section group. `scopeKey` namespaces the entry
// (form token / layout panel) so hosts that reuse section names don't collide.
export const useSectionTabState = (
  scopeKey: string,
  groupKey: string
): [number, (index: number) => void] => {
  const storageKey = `sectionTab:${scopeKey}:${groupKey}`;
  const [state, setState] = useState<{ storageKey: string; index: number }>(
    () => ({ storageKey, index: readStoredIndex(storageKey) })
  );

  // Scope or section set changed without a remount — re-read the new entry
  // instead of carrying (and later persisting) the previous group's index.
  if (state.storageKey !== storageKey) {
    setState({ storageKey, index: readStoredIndex(storageKey) });
  }

  const setActiveTab = (index: number): void => {
    setState({ storageKey, index });
    sessionStorage.setItem(storageKey, String(index));
  };

  return [state.index, setActiveTab];
};
